import httpClient from "@/apis/base/httpclient";
import api from "@/apis/system/tenantAPI";
import Crud from "@/stores/crudBase";

var crud = new Crud("Tenant", api);

const state = {
  ...crud.state,

  _config: {
    field: {
      key: "TenantID",
      name: "TenantName",
    },
  },
  datas: [],
};

const getters = {
  ...crud.getters,
};

/**
 * Chứa các hàm action
 */
const actions = {
  ...crud.actions,


   /**
   * Lấy thông tin đơn vị theo ID
   * VDGiang 10/11/2022
   * @param {*} context 
   * @param {*} payload 
   * @returns 
   */
 getTenantInfor: async function (context) {
    context.commit("updateLoading", true);
    let request = {
      url: api.getAPIUrl(),
    }
    try {
      let res = await httpClient.getAsync(request);
      return res;
    } catch (err) {
      console.error(err);
    } finally {
      context.commit("updateLoading", false);
    }
  },

  /**
  * Lưu thông tin đơn vị
  * VDGiang 10/11/2022
  */
   async updateTenantInfor(context, payload) {
    context.commit("updateLoading", true);
    let res = await api.updateTenantInfor(payload || {});
    context.commit("updateLoading", false);

    if (res) {
      res.payload = payload;
    }

    return res;
  },
}

const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
